const MIN_QTY    = 1;
const MAX_QTY    = 999;
const SESSION_KEY = 'rhHire';

const initStepQuantity = () => {
  const stepEl = document.querySelector('#rh-step-2:not([data-rh-init])');
  if (!stepEl) return;
  stepEl.dataset.rhInit = 'true';

  let qty = 1;

  const saved = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
  if (saved.quantity && saved.quantity >= MIN_QTY) {
    qty = parseInt(saved.quantity);
  }

  const valueEl  = document.getElementById('rh-qty-value');
  const minusBtn = document.getElementById('rh-qty-minus');
  const plusBtn  = document.getElementById('rh-qty-plus');

  function render() {
    valueEl.value     = qty;
    minusBtn.disabled = qty <= MIN_QTY;
    plusBtn.disabled  = qty >= MAX_QTY;
  }

  minusBtn.addEventListener('click', function () {
    if (qty > MIN_QTY) { qty--; render(); }
  });

  plusBtn.addEventListener('click', function () {
    if (qty < MAX_QTY) { qty++; render(); }
  });

  valueEl.addEventListener('input', function () {
    const parsed = parseInt(valueEl.value, 10);
    if (!isNaN(parsed)) {
      qty = Math.min(MAX_QTY, Math.max(MIN_QTY, parsed));
      minusBtn.disabled = qty <= MIN_QTY;
      plusBtn.disabled  = qty >= MAX_QTY;
    }
  });

  valueEl.addEventListener('blur', function () {
    render();
  });

  function goBack() {
    const url = new URL(window.location.href);
    url.searchParams.set('step', '1');
    window.location.href = url.toString();
  }

  function goNext() {
    const hire = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
    hire.quantity = qty;
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(hire));
    const url = new URL(window.location.href);
    url.searchParams.set('step', '3');
    window.location.href = url.toString();
  }

  document.getElementById('rh-back-2').addEventListener('click', goBack);
  document.getElementById('rh-next-2').addEventListener('click', goNext);
  document.getElementById('rh-next-2-arrow').addEventListener('click', goNext);

  render();
};

export default initStepQuantity;
